@if (isBrowserPlatform()) {
<div libFlexRow>
	<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : '400px'">
		<lib-card [enableCard]="isMobileView() ? false : true">
			<emoji-picker [class.dark]="theme() === 'dark'" [class.light]="theme() === 'light'"></emoji-picker>
		</lib-card>
	</div>
</div>
}
